import { useId } from 'react'
import Image from 'next/image'
import { cloudflareLoader } from '@mc/image-cloudflare'
import type { CohortContent } from '../types'

export const CohortPartners = ({
  partners,
}: {
  partners: CohortContent['partners']
}) => {
  const headingId = useId()

  if (!partners.items.length) return null

  return (
    // -mt-8 cancels CohortInstructors' py-8 so the card sits a bio-card gap (gap-7) below the last bio
    <section aria-labelledby={headingId} className='-mt-8 pb-8 pt-7'>
      <div className='lg:container'>
        <div className='flex flex-col gap-7 rounded-lg bg-c-base-100 p-6 lg:gap-6 lg:p-7'>
          <h2 id={headingId} className='c-heading-1 m-0 text-c-text-dark'>
            {partners.title}
          </h2>
          <ul className='m-0 flex list-none flex-col divide-y divide-dotted divide-c-text-tint-2 p-0 lg:flex-row lg:divide-x lg:divide-y-0'>
            {partners.items.map(({ logo, description }) => (
              <li
                key={logo.url}
                className='flex flex-1 items-center gap-6 py-6 first:pt-0 last:pb-0 lg:gap-5 lg:px-6 lg:py-0 lg:first:pl-0 lg:last:pr-0'
              >
                <Image
                  src={logo.url}
                  alt={logo.alt}
                  width={100}
                  height={70}
                  loader={cloudflareLoader}
                  className='shrink-0 object-contain'
                />
                <p className='c-body-small m-0 text-c-text-tint-3'>
                  {description}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
